import { cloneDeep, isEqual } from "lodash-es"
const _cachedJsonData = {}
window.__cachedData = _cachedJsonData
export async function cacheData<T>(
  id: string,
  fn: () => Promise<T>,
  when: (data: T) => boolean = () => true,
) {
  if (_cachedJsonData[id]) return cloneDeep(_cachedJsonData[id]) as T
  const data = await fn()
  if (when(data)) {
    _cachedJsonData[id] = data
  }

  return data
}

export function cacheRequest<T>(id: string, fn: () => Promise<T>) {
  return cacheData(id, fn, (res: any) => res.code === 1000)
}

export async function loadJsonData(url: string, version?: string) {
  return cacheData(url, async () => {
    return fetch(`${url}?v=${version ?? Date.now()}`).then((res) => res.json())
  })
}

const _matchCacheData: Record<string, any> = {}

// 再useEffect里边用，避免死循环
export function matchCacheData<T>(key: string, newData: T) {
  const isSame = isEqual(newData, _matchCacheData[key])
  if (!isSame) {
    _matchCacheData[key] = cloneDeep(newData)
  }
  return {
    isSame,
    oldData: _matchCacheData[key],
  }
}
